import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AppointmentServicesAPI from '../../api/appointmentServices';
import { extractRecord, extractList } from '../utils/appointmentEnvelope';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchError: false,
  },
};

export const getters = {
  getAppointmentServices(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAppointmentServiceById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getAppointmentServices({ commit }) {
    commit(types.SET_APPOINTMENT_SERVICE_UI_FLAG, {
      isFetching: true,
      isFetchError: false,
    });
    try {
      const response = await AppointmentServicesAPI.get();
      commit(types.SET_APPOINTMENT_SERVICES, extractList(response));
    } catch {
      commit(types.SET_APPOINTMENT_SERVICE_UI_FLAG, { isFetchError: true });
    } finally {
      commit(types.SET_APPOINTMENT_SERVICE_UI_FLAG, { isFetching: false });
    }
  },

  // Audit fase-29 P0 — try/finally (sem catch) para preservar `error.response`
  // intacto até o caller, como já feito em appointmentsModule.js (incidente
  // 2026-05-07). O `throw new Error(error.response.data.message)` anterior
  // destruía `error.response` (o backend devolve `{errors: {...}}`, não
  // `message`), virando `Error("undefined")` e mostrando erro genérico/vazio.
  create: async function createAppointmentService({ commit }, serviceData) {
    commit(types.SET_APPOINTMENT_SERVICE_UI_FLAG, { isCreating: true });
    try {
      const response = await AppointmentServicesAPI.create(serviceData);
      commit(types.ADD_APPOINTMENT_SERVICE, extractRecord(response));
      return extractRecord(response);
    } finally {
      commit(types.SET_APPOINTMENT_SERVICE_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateAppointmentService(
    { commit },
    { id, ...updateData }
  ) {
    commit(types.SET_APPOINTMENT_SERVICE_UI_FLAG, { isUpdating: true });
    try {
      const response = await AppointmentServicesAPI.update(id, updateData);
      commit(types.EDIT_APPOINTMENT_SERVICE, extractRecord(response));
      return extractRecord(response);
    } finally {
      commit(types.SET_APPOINTMENT_SERVICE_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteAppointmentService({ commit }, id) {
    commit(types.SET_APPOINTMENT_SERVICE_UI_FLAG, { isDeleting: true });
    try {
      await AppointmentServicesAPI.delete(id);
      commit(types.DELETE_APPOINTMENT_SERVICE, id);
    } finally {
      commit(types.SET_APPOINTMENT_SERVICE_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_APPOINTMENT_SERVICE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_APPOINTMENT_SERVICES]: MutationHelpers.set,
  [types.ADD_APPOINTMENT_SERVICE]: MutationHelpers.create,
  [types.EDIT_APPOINTMENT_SERVICE]: MutationHelpers.update,
  [types.DELETE_APPOINTMENT_SERVICE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
